






















































import { ChoiceOption, ChoiceOptionList } from '@/interfaces';
import { api } from '@/api';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AutoCompleteField extends Vue {
  @Prop(String) public label;
  @Prop(String) public readonly field!: string;
  @Prop(Object) public readonly rec!: object;
  @Prop(String) public readonly url!: string;
  @Prop({ type: Boolean, default: false }) public readonly required!: boolean;
  @Prop({ type: Boolean, default: false }) public readonly isReadOnly!: boolean;
  @Prop({ type: String, default: '3' }) public readonly labelCols!: string;
  @Prop({ type: String, default: '9' }) public readonly inputCols!: string;
  @Prop({ type: Number, default: 4 }) public readonly minChars!: number;
  @Prop({ type: Boolean, default: true }) public readonly clearable!: boolean;

  public textValue: string = this.rec[this.field] ? this.rec[this.field] : '';
  public validateErrors: string[] = [];
  public dialog = false;
  public loading = false;
  public foundItems: string[] = [];
  public searchResult: string = '';

  public myrules = {
    required: (v) => {
      return !!v || 'Dit veld is verplicht.';
    }
  };

  public get allRules() {
    const rules = [] as any;
    if (this.required) {
      rules.push(this.myrules.required);
    }
    return rules;
  }

  public async doSearch(theSearchString) {
    console.log('AutoCompleteField.doSearch', theSearchString);
    this.loading = true;
    const data = await api.getAutoCompleteList(this.$store, this.url, {v: theSearchString});
    console.log(data);
    if (data) {
      if (this.textValue === theSearchString) {
        this.foundItems = data.records;
        if (this.foundItems.length === 1) {
          this.setValue(this.foundItems[0]);
        } else if (this.foundItems.length > 1) {
          this.searchResult = this.foundItems[0];
          this.dialog = true;
        }
      } else {
        console.log('AutoCompleteField.doSearch mismatch', this.textValue, theSearchString);
      }
    }
    this.loading = false;
  }
  public setValue(item) {
    console.log('AutoCompleteField.setValue', item);
    this.rec[this.field] = this.textValue = item;
  }
  public async textInput(v) {
    console.log('AutoCompleteField.textInput', v);
    if (v === null) {
        this.textValue = '';
    }
    // if (v === null) {
    //     this.textValue = '';
    // } else if (v && v.length >= this.minChars) {
    //   this.doSearch(v);
    // }
  }
  public async textInputDelay(v) {
    console.log('AutoCompleteField.textInputDelay', v);
    if (v === null) {
        this.textValue = '';
    } else if (v && v.length >= this.minChars && v.charAt(0) !== '_') {
      this.doSearch(v);
    }
  }

  public textChange(e) {
    console.log('AutoCompleteField.textChange', this.textValue, e);
  }
  public textEnter(e) {
    console.log('AutoCompleteField.textEnter', e);
    // this.synchronizeText();
    this.$emit('enter', e);
  }
  public textBlur(e) {
    let v = this.textValue;
    console.log('AutoCompleteField.textBlur', v);
    if (v.charAt(0) === '_') {
      v = v.slice(1);
    }
    if (this.rec[this.field] !== v) {
        this.setValue(v);
    }
    this.$emit('blur', e);
  }
  public created() {
    this.$watch(
      function() { return this.rec[this.field]; },
      function(newValue, oldValue) {
          console.log('AutoCompleteField.$watch', oldValue, '->',  newValue);
          if (oldValue !== newValue) {
            this.textValue = newValue ? newValue : '';
          }
        }
    );
  }


}
